import { get, post, put, delete as remove } from 'axios'

const endpoint = '/action-plans'
const task = t => ({ text: t, done: false })

const formatResponseData = templates =>
  templates
    .filter(template => template.tasks)
    .map(template => ({ ...template, tasks: template.tasks.map(task) }))

export const getTemplates = (metrics, exclude) =>
  get('action-plans/templates', { params: { metrics, exclude } })
    .then(r => r.data.templates)
    .then(formatResponseData)

export const getActionPlans = params => {
  return get(endpoint, { params }).then(res => res.data)
}

const taskTrim = tasks => tasks.filter(({ text }) => text.trim())

const normalize = data => {
  data = JSON.parse(JSON.stringify(data))
  if (!data.groupId || data.groupId === 'company') delete data.groupId
  data.metricId = data.metric._id
  delete data._id
  delete data.metric

  return {
    ...data,
    tasks: taskTrim(data.tasks),
  }
}

const normalizeToPut = ({ title, description, tasks }) => ({
  title,
  description,
  tasks: taskTrim(tasks),
})

export const saveActionPlan = data => post(`${endpoint}`, normalize(data))

export const updateActionPlan = data =>
  put(`${endpoint}/${data._id}`, normalizeToPut(data))

export const removeActionPlan = actionPlanId =>
  remove(`${endpoint}/${actionPlanId}`)

export default {
  getTemplates,
  getActionPlans,
  saveActionPlan,
  removeActionPlan,
}
